import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import { setConfig } from 'react-hot-loader';
import { hot } from 'react-hot-loader/root';
import Flux from 'flux';
import React from 'react';
import ErrorCatcher from '@haptik/helpers/build/esm/errorCatcher';

import { CRASH_URL } from '@src/const';

import AppRoot from './Router';
import './styles/main.scss';

class App extends React.Component {
  constructor() {
    super();
    this.dispatcher = new Flux.Dispatcher();
  }

  render() {
    return (
      <ErrorCatcher url={CRASH_URL}>
        <AppRoot />
      </ErrorCatcher>
    );
  }
}

setConfig({
  ignoreSFC: true,
  pureRender: true,
});

export default hot(App);
